module.exports = __webpack_public_path__ + "static/img/305.d82229a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/191025/305.jpg
// module id = vDw3
// module chunks = 0